import type {ComponentPropsWithRef, ReactNode} from 'react';
import React, {Children} from 'react';
import {withCssModule, hashedClasses} from '@pb/kit-util-with-css-module';

import styles from './table.module.styl';

const classNames = withCssModule(styles);
const classes = hashedClasses(styles);

export type HeadlineProps = ComponentPropsWithRef<'div'> & {
    /**
     * Table head cell top text
     */
    topCaption?: ReactNode,
    /**
     * Table head cell caption
     */
    caption: ReactNode,
    /**
     * Mix for Headline
     */
    mix?: string,
};

/**
 * @deprecated This component will be removed in 6 months 03-03-2026.
 * Create custom layouts on the consumer side instead.
 */
export const Headline = ({
    topCaption,
    caption,
    children,
    mix,
    className,
    ref,
    ...rest
}: HeadlineProps) => {
    const headlineClasses = classNames('table__headline', mix, className);

    return (
        <div {...rest} ref={ref} className={headlineClasses}>
            {topCaption ? <div className={classes.table__subtitle}>{topCaption}</div> : null}
            <div className={classes.table__title}>{caption}</div>
            {Children.count(children) ? <div className={classes.table__subtitle}>{children}</div> : null}
        </div>
    );
};
